import { useEffect, useState } from "react";
import { getFeaturedRecipes } from "../api/recipes";
import { FetchedRecipe } from "../types/recipe";

export function useFeaturedRecipes() {
  const [recipes, setRecipes] = useState<FetchedRecipe[]>(
    [] as FetchedRecipe[]
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFeaturedRecipes()
      .then(setRecipes)
      .finally(() => setLoading(false));
  }, []);

  return { recipes, loading };
}
